import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";

const PrinterAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label = "Printers", load = true, infoText, disabled = false, error, helperText}) => {
    return (
        <AsyncAutoCompleteContained
            label={label}
            url="/autocompleteApi/GetPrinters"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={ disabled}
        />
    );
};

export default PrinterAutoComplete;
